import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate } from '@angular/router';
import { ModalLayoutComponent } from './core/layouts/modal-layout/modal-layout.component';
import { SessionService } from '@auth/auth';
import { FunctionalRoleGuard } from './core/guards/functional/functional-role.guard';
import { LoginGuard } from './core/guards/route/login.guard';
import { ClaimStatusService, ReserveTypeService, StateService } from './core/services';
import { SelectProgramGuard } from './core/guards/route/select-program.guard';
import { UnsavedChangesGuard } from './core/guards/route/unsaved-changes.guard.guard';

export const routes: Routes = [  
  {
    path: 'not-found',
    loadComponent: () => import(`./core/pages/not-found/not-found.component`).then(x => x.NotFoundComponent)
  },
  {
    path: 'session',
    children: [
      {
        path: 'general-error/unauthorized',
        loadComponent: () => import(`./features/session/error/authorization-error/authorization-error.component`).then(x => x.AuthorizationErrorComponent)
      }, {
        path: 'error',
        loadComponent: () => import(`./features/session/error/generic-error/generic-error.component`).then(x => x.GenericErrorComponent)
      }, {
        path: 'logout',
        loadComponent: () => import(`./features/session/logout/logout.component`).then(x => x.LogoutComponent)
      }, {
        path: 'callback',
        redirectTo: 'reports',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    canActivate: [LoginGuard],
    children: [
      {
        path: '',
        loadComponent: () => import(`./features/reporting/layouts/full-reporting/full-reporting.component`).then(x => x.FullReportingComponent),
        children: [
          {
            path: '',
            loadComponent: () => import(`./features/reporting/dashboard/dashboard.component`).then(x => x.DashboardComponent)
          }
        ]
      },
      {
        path: ':reportid',
        loadComponent: () => import(`./features/reporting/layouts/full-reporting/full-reporting.component`).then(x => x.FullReportingComponent),
        children: [
          {
            path: 'overview',
            loadComponent: () => import(`./features/reporting/screens/overview/overview.component`).then(x => x.OverviewComponent)
          }, {
            path: 'select-account',
            loadComponent: () => import(`./features/reporting/screens/account-selection/account-selection.component`).then(x => x.AccountSelectionComponent)
          }, {
            canActivate: [SelectProgramGuard],
            path: 'select-program',
            loadComponent: () => import(`./features/reporting/screens/program-selection/program-selection.component`).then(x => x.ProgramSelectionComponent)
          }, {
            path: 'valuation-date',
            loadComponent: () => import(`./features/reporting/screens/point-in-time/point-in-time.component`).then(x => x.PointInTimeComponent)
          }, {
            path: 'build-query',
            loadComponent: () => import(`./features/reporting/screens/build-query/build-query.component`).then(x => x.BuildQueryComponent)
          }, {
            path: 'date-selection',
            loadComponent: () => import(`./features/reporting/screens/date-selection/date-selection.component`).then(x => x.DateSelectionComponent)
          }, {
            path: 'field-selection',
            loadComponent: () => import(`./features/reporting/screens/choose-columns/choose-columns.component`).then(x => x.ChooseColumnsComponent)
          }, {
            path: 'order-columns',
            loadComponent: () => import(`./features/reporting/screens/order-columns/order-columns.component`).then(x => x.OrderColumnsComponent)
          }, {
            path: 'review',
            loadComponent: () => import(`./features/reporting/screens/review-config/review-config.component`).then(x => x.ReviewConfigComponent)
          }, {
            path: 'requested',
            loadComponent: () => import(`./features/reporting/screens/running-report/running-report.component`).then(x => x.RunningReportComponent)
          }, {
            path: 'scheduling',
            loadComponent: () => import(`./features/reporting/screens/scheduling/scheduling.component`).then(x => x.SchedulingComponent)
          }, { 
            path: '', 
            redirectTo: 'overview', 
            pathMatch: 'full' 
          }, { 
            path: '**', 
            redirectTo: 'session/error' 
          }
        ],
        canDeactivate: [UnsavedChangesGuard]
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  }, {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  }, {
    path: '**',
    redirectTo: 'session/error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    SessionService,
    StateService,
    ClaimStatusService,
    ReserveTypeService
  ]
})
export class AppRoutingModule { }
